<section class="cost-km-calculator" aria-labelledby="cost-km-calculator-title">
    <header class="cost-km-calculator__header">
        <div>
            <div class="cost-km-calculator__eyebrow">Калькулятор стоимости километра</div>
            <h2 id="cost-km-calculator-title">Посчитайте по данным своей машины</h2>
            <p>Топливо — только часть расходов. Добавьте пробег и расходы за последние 12 месяцев, чтобы увидеть честную цену километра.</p>
        </div>
        <div class="cost-km-calculator__example-note">
            <strong>Пример за последние 12 месяцев</strong>
            <span>Мы подставили примерные годовые значения. Замените их данными своей машины за тот же срок.</span>
        </div>
    </header>

    <div class="cost-km-calculator__tabs" role="tablist" aria-label="Режим расчёта">
        <button
            type="button"
            role="tab"
            id="cost-km-full-tab"
            aria-controls="cost-km-full-panel"
            [attr.aria-selected]="mode === 'full'"
            [class.cost-km-calculator__tab--active]="mode === 'full'"
            (click)="selectMode('full')"
        >
            Полная стоимость
            <small>расходы за последние 12 месяцев</small>
        </button>
        <button
            type="button"
            role="tab"
            id="cost-km-fuel-tab"
            aria-controls="cost-km-fuel-panel"
            [attr.aria-selected]="mode === 'fuel'"
            [class.cost-km-calculator__tab--active]="mode === 'fuel'"
            (click)="selectMode('fuel')"
        >
            Только топливо
            <small>расход и цена литра</small>
        </button>
    </div>

    <div class="cost-km-calculator__workspace"
         role="tabpanel"
         [attr.id]="mode === 'full' ? 'cost-km-full-panel' : 'cost-km-fuel-panel'"
         [attr.aria-labelledby]="mode === 'full' ? 'cost-km-full-tab' : 'cost-km-fuel-tab'">
        <form class="cost-km-calculator__form" aria-label="Данные для расчёта стоимости километра">
            <div class="cost-km-calculator__form-heading">
                <strong>{{ mode === 'full' ? 'Данные за последние 12 месяцев' : 'Расход и цена топлива' }}</strong>
                <span>{{ mode === 'full' ? 'Возьмите текущий пробег и расходы за год до сегодняшней даты.' : 'Километраж поездки не нужен: цена топлива на километр зависит от расхода и цены литра.' }}</span>
            </div>

            <div class="cost-km-calculator__example-note" role="note" *ngIf="mode === 'full'">
                <strong>Период расчёта: последние 12 месяцев</strong>
                <span>Введите пробег и все суммы именно за этот срок. Не смешивайте месячные расходы с годовыми.</span>
            </div>

            <div class="cost-km-calculator__fields" [class.cost-km-calculator__fields--fuel]="mode === 'fuel'">
                <label class="cost-km-calculator__field" *ngIf="mode === 'full'">
                    <span>Пробег за 12 месяцев</span>
                    <div class="cost-km-calculator__input-postfix">
                        <input type="number" inputmode="numeric" min="1" step="100"
                               [ngModel]="mileage" [ngModelOptions]="{standalone: true}"
                               (ngModelChange)="onValueChange('mileage', $event)" (focus)="onInputFocus($event)">
                        <span>км</span>
                    </div>
                </label>

                <label class="cost-km-calculator__field">
                    <span>Средний расход</span>
                    <div class="cost-km-calculator__input-postfix">
                        <input type="number" inputmode="decimal" min="0.1" step="0.1"
                               [ngModel]="consumption" [ngModelOptions]="{standalone: true}"
                               (ngModelChange)="onValueChange('consumption', $event)" (focus)="onInputFocus($event)">
                        <span>л/100 км</span>
                    </div>
                </label>

                <label class="cost-km-calculator__field">
                    <span>Цена литра</span>
                    <div class="cost-km-calculator__input-postfix">
                        <input type="number" inputmode="decimal" min="0.01" step="0.01"
                               [ngModel]="fuelPrice" [ngModelOptions]="{standalone: true}"
                               (ngModelChange)="onValueChange('fuelPrice', $event)" (focus)="onInputFocus($event)">
                        <span>₽/л</span>
                    </div>
                </label>

                <ng-container *ngIf="mode === 'full'">
                    <label class="cost-km-calculator__field">
                        <span>ТО и ремонт за 12 месяцев</span>
                        <div class="cost-km-calculator__input-postfix">
                            <input type="number" inputmode="numeric" min="0" step="1000"
                                   [ngModel]="maintenance" [ngModelOptions]="{standalone: true}"
                                   (ngModelChange)="onValueChange('maintenance', $event)" (focus)="onInputFocus($event)">
                            <span>₽</span>
                        </div>
                    </label>

                    <label class="cost-km-calculator__field">
                        <span>Страховка и налог за 12 месяцев</span>
                        <div class="cost-km-calculator__input-postfix">
                            <input type="number" inputmode="numeric" min="0" step="1000"
                                   [ngModel]="insuranceAndTax" [ngModelOptions]="{standalone: true}"
                                   (ngModelChange)="onValueChange('insuranceAndTax', $event)" (focus)="onInputFocus($event)">
                            <span>₽</span>
                        </div>
                    </label>

                    <label class="cost-km-calculator__field">
                        <span>Шины, мойка и уход за 12 месяцев</span>
                        <div class="cost-km-calculator__input-postfix">
                            <input type="number" inputmode="numeric" min="0" step="1000"
                                   [ngModel]="tyresAndCare" [ngModelOptions]="{standalone: true}"
                                   (ngModelChange)="onValueChange('tyresAndCare', $event)" (focus)="onInputFocus($event)">
                            <span>₽</span>
                        </div>
                    </label>

                    <label class="cost-km-calculator__field">
                        <span>Парковка и прочее за 12 месяцев</span>
                        <div class="cost-km-calculator__input-postfix">
                            <input type="number" inputmode="numeric" min="0" step="1000"
                                   [ngModel]="otherExpenses" [ngModelOptions]="{standalone: true}"
                                   (ngModelChange)="onValueChange('otherExpenses', $event)" (focus)="onInputFocus($event)">
                            <span>₽</span>
                        </div>
                    </label>

                    <label class="cost-km-calculator__field cost-km-calculator__field--wide">
                        <span>Потеря стоимости автомобиля за 12 месяцев</span>
                        <div class="cost-km-calculator__input-postfix">
                            <input type="number" inputmode="numeric" min="0" step="5000"
                                   [ngModel]="depreciation" [ngModelOptions]="{standalone: true}"
                                   (ngModelChange)="onValueChange('depreciation', $event)" (focus)="onInputFocus($event)">
                            <span>₽</span>
                        </div>
                        <small>Не хотите учитывать амортизацию — укажите 0.</small>
                    </label>
                </ng-container>
            </div>
        </form>

        <aside class="cost-km-calculator__result" aria-live="polite">
            <ng-container *ngIf="mode === 'full'; else fuelResult">
                <div class="cost-km-calculator__primary-result">
                    <span>Полная стоимость 1 км</span>
                    <strong>{{ formatMoney(fullCostPerKm(), 2) }}<small>/км</small></strong>
                    <p>Включает текущие расходы и потерю стоимости автомобиля.</p>
                </div>

                <div class="cost-km-calculator__secondary-results">
                    <div>
                        <span>Без амортизации</span>
                        <strong>{{ formatMoney(operatingCostPerKm(), 2) }}/км</strong>
                    </div>
                    <div>
                        <span>Только топливо</span>
                        <strong>{{ formatMoney(fuelCostPerKm(), 2) }}/км</strong>
                    </div>
                    <div>
                        <span>Всего за 12 месяцев</span>
                        <strong>{{ formatMoney(fullExpenses()) }}</strong>
                    </div>
                </div>

                <div class="cost-km-calculator__breakdown" *ngIf="hasCalculation()">
                    <div class="cost-km-calculator__breakdown-title">Расходы за последние 12 месяцев</div>
                    <div class="cost-km-calculator__breakdown-row" *ngFor="let item of breakdown()">
                        <div>
                            <span>{{ item.label }}</span>
                            <strong>{{ formatMoney(item.amount) }}</strong>
                        </div>
                        <span class="cost-km-calculator__bar">
                            <span [ngClass]="'cost-km-calculator__bar-fill--' + item.tone"
                                  [style.width.%]="barPercent(item.amount)"></span>
                        </span>
                    </div>
                </div>
            </ng-container>

            <ng-template #fuelResult>
                <div class="cost-km-calculator__primary-result cost-km-calculator__primary-result--fuel">
                    <span>Только топливо на 1 км</span>
                    <strong>{{ formatMoney(fuelCostPerKm(), 2) }}<small>/км</small></strong>
                    <p>{{ formatNumber(consumption, 1) }} л на 100 км × {{ formatMoney(fuelPrice, 2) }} за литр.</p>
                </div>
                <div class="cost-km-calculator__fuel-explanation">
                    <strong>Это не полная стоимость автомобиля</strong>
                    <p>Обслуживание, ремонт, страховка, шины и амортизация тоже становятся частью каждого километра.</p>
                    <button type="button" (click)="selectMode('full')">Добавить остальные расходы</button>
                    <p>Ниже эту цену километра можно применить к маршруту между городами.</p>
                </div>
            </ng-template>

            <div class="cost-km-calculator__actions">
                <a class="cost-km-calculator__button cost-km-calculator__button--primary"
                   [href]="registrationUrl()" (click)="trackRegistrationClick()">
                    Сохранить расчёт для моей машины
                </a>
                <a class="cost-km-calculator__button cost-km-calculator__button--secondary"
                   [href]="demoUrl()" (click)="trackDemoClick()">
                    Посмотреть пример истории
                </a>
            </div>
            <p class="cost-km-calculator__product-note">MotorDesk будет пересчитывать стоимость по мере добавления
                пробега, заправок и обслуживания.</p>
        </aside>
    </div>

    <section class="cost-km-calculator__route-estimator"
             id="cost-km-route-estimator"
             aria-labelledby="cost-km-route-title">
        <header class="cost-km-calculator__route-header">
            <div>
                <div class="cost-km-calculator__eyebrow">Маршрут по вашей цене километра</div>
                <h3 id="cost-km-route-title">Сколько будет стоить поездка между городами</h3>
                <p>Выберите города — рассчитаем расстояние по дорогам и применим к нему получившуюся стоимость
                    километра.</p>
            </div>
            <button class="cost-km-calculator__route-toggle"
                    type="button"
                    aria-controls="cost-km-route-panel"
                    [attr.aria-expanded]="routeEstimatorOpen"
                    (click)="toggleRouteEstimator()">
                <span>{{ routeEstimatorOpen ? 'Скрыть маршрут' : 'Выбрать города' }}</span>
                <svg viewBox="0 0 20 20" aria-hidden="true"
                     [class.cost-km-calculator__route-toggle-icon--open]="routeEstimatorOpen">
                    <path d="m5 7.5 5 5 5-5"></path>
                </svg>
            </button>
        </header>

        <div class="cost-km-calculator__route-panel"
             id="cost-km-route-panel"
             *ngIf="routeEstimatorOpen">
            <app-route-planner
                [compact]="true"
                context="trip"
                (routeCalculated)="onRouteCalculated($event)"
                (routeInvalidated)="onRouteInvalidated()"
            ></app-route-planner>

            <aside class="cost-km-calculator__route-result"
                   [class.cost-km-calculator__route-result--empty]="!routeResult"
                   aria-live="polite"
                   aria-atomic="true">
                <ng-container *ngIf="routeResult; else routePrompt">
                    <div class="cost-km-calculator__route-caption">
                        <span>{{ routeResult.round_trip ? 'Туда и обратно' : 'В одну сторону' }}</span>
                        <strong>{{ routeResult.origin.name }} — {{ routeResult.destination.name }}</strong>
                    </div>

                    <div class="cost-km-calculator__route-primary">
                        <span>{{ mode === 'full' ? 'Полная стоимость маршрута' : 'Топливо на маршрут' }}</span>
                        <strong>{{ formatMoney(routePrimaryCost()) }}</strong>
                        <p>{{ formatMoney(routeAppliedCostPerKm(), 2) }}/км × {{ formatNumber(routeDistance(), 1) }}
                            км</p>
                    </div>

                    <div class="cost-km-calculator__route-metrics" *ngIf="mode === 'full'; else fuelRouteMetrics">
                        <div>
                            <span>Без амортизации</span>
                            <strong>{{ formatMoney(routeOperatingCost()) }}</strong>
                        </div>
                        <div>
                            <span>Только топливо</span>
                            <strong>{{ formatMoney(routeFuelCost()) }}</strong>
                        </div>
                        <div>
                            <span>Понадобится топлива</span>
                            <strong>{{ formatNumber(routeFuelLitres(), 1) }} л</strong>
                        </div>
                    </div>

                    <ng-template #fuelRouteMetrics>
                        <div class="cost-km-calculator__route-metrics cost-km-calculator__route-metrics--fuel">
                            <div>
                                <span>Понадобится топлива</span>
                                <strong>{{ formatNumber(routeFuelLitres(), 1) }} л</strong>
                            </div>
                            <div>
                                <span>Цена километра</span>
                                <strong>{{ formatMoney(fuelCostPerKm(), 2) }}</strong>
                            </div>
                        </div>
                    </ng-template>

                    <p class="cost-km-calculator__route-note" *ngIf="mode === 'full'">
                        Полная оценка распределяет годовые расходы и потерю стоимости автомобиля по пройденным
                        километрам. Фактические расходы именно в день поездки будут ниже.
                    </p>
                    <p class="cost-km-calculator__route-note" *ngIf="mode === 'fuel'">
                        В этом режиме учитывается только топливо. Для полной оценки добавьте обслуживание, страховку,
                        уход и потерю стоимости автомобиля.
                    </p>
                </ng-container>

                <ng-template #routePrompt>
                    <div class="cost-km-calculator__route-prompt">
                        <span aria-hidden="true">↗</span>
                        <strong>Сначала выберите два города</strong>
                        <p>После построения маршрута здесь появится расчёт по вашей стоимости километра.</p>
                    </div>
                </ng-template>
            </aside>
        </div>

        <div class="cost-km-calculator__route-links">
            <a [routerLink]="APP_ROUTES.ROUTE_DISTANCE.INDEX">Отдельный расчёт расстояния</a>
            <a [routerLink]="APP_ROUTES.TRIP_CALCULATOR.INDEX" fragment="trip-calculator">Калькулятор поездки по
                топливу</a>
        </div>
    </section>
</section>
